import axios from 'axios';

export function initAxios() {
  const csrfTag: HTMLMetaElement = document.querySelector(
    'meta[name=csrf-token]'
  );
  if (csrfTag) {
    axios.defaults.headers.common['X-CSRF-Token'] = csrfTag.content;
  }
  return axios.create({
    baseURL: (window as any).__proffSpa___?.apiBasePath || '',
  });
}
